// extracted by mini-css-extract-plugin
export default {"container":"promotion-brand-logo__container___2wl5G","brand-logo":"promotion-brand-logo__brand-logo___3CIjq"};